<div class="div_venue">
    <div class="pos-title-header">  
      <label class="lbl_top">{{'VENUE.MY_VENUES' | translate}}</label>
    </div>
    <div class="cards_div_wrapper">
        <p-progressSpinner class="w-100 text-center pos_spiner" *ngIf="spinner"></p-progressSpinner>
        <div *ngFor="let venues of listAllVenues" class="div_card_venue cursor-pointer">
            <label class="my_venue"> {{'VENUE.MY_VENUE' | translate}}</label>
            <div (click)="navigateToDivisions(venues.id)">
              <div class="py-2 d-flex align-items-center">
                <img class="m-2 venue-logo"
                     [src]="venues.pictureUrl ? venues.pictureUrl : imagePath "
                     alt="profile-picture">
                <label class="venue-name cursor-pointer" title="{{venues.name}}">{{venues.name}}</label>
              </div>
              <div class="my-2">
                <div class="my-2">
                  <label class="w_100_mobile w-40 cursor-pointer lbl-venue">{{'VENUE.PHONE_NUMBER' | translate}}</label>
                  <label class="w_100_mobile w-60 cursor-pointer lbl-venue-value">{{venues.phone}}</label>
                </div>
                <div class="my-2 d-flex align-items-center">
                  <label class="w_100_mobile w-40 cursor-pointer lbl-venue">{{'VENUE.VENUE_ADDRESS' | translate}}</label>
                  <label class="w_100_mobile w-60 cursor-pointer venue-address" title="{{venues.address}}">{{venues.address}}</label>
                </div>
                <div class="my-2">
                  <label class="w_100_mobile w-40 cursor-pointer lbl-venue">{{'VENUE.VENUE_PRINTER_KEY' | translate}}</label>
                  <label class="w_100_mobile w-60 cursor-pointer lbl-venue-value" title="{{venues.fiscalPrinterCode}}">{{venues.fiscalPrinterCode}}</label>
                </div>    
              </div>
            <button *ngIf="!venues.hasCapacity" class="btn-create-capacity-venue w-100" (click)="createCapacityForVenue($event, venues.id, venues.name)" >{{'VENUE.CREATE_TABLE_CAPACITY' |translate}}</button>
            <button *ngIf="venues.hasCapacity" class="btn-see-capacity-venue w-100" (click)="createCapacityForVenue($event, venues.id, venues.name)" >{{'VENUE.SEE_TABLE_CAPACITY' |translate}}</button>
        </div>
    </div>
</div>
